module.exports = "https://cdn-shared.mathletics.com/teacher-modules/assessments-assign/66/assets/fonts/8b6af8e5e8324edfd77af8b3b35d7f9c.ttf";